// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const sulfurVent = defineModel({
  id: "sulfur-vent",
  batchId: "future",
  name: "Sulfur vent",
  tags: ["scenery","sulfur","vent","low-poly","age-of-mcp","future"],
  summary: "A volcanic sulfur vent. Feeds gunpowder, matches and medicine.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.45,
  parts: () => [
      { geometry: new THREE.IcosahedronGeometry(0.26, 0), color: "#75787f", position: [-0.16, 0.18, 0.02], rotation: [0.06, 0.4, 0.18], scale: [1, 1, 1.05] },
      { geometry: new THREE.IcosahedronGeometry(0.24, 0), color: "#676a71", position: [0.18, 0.17, -0.02], rotation: [0.05, 1.2, -0.2], scale: [1, 0.95, 1] },
      { geometry: new THREE.TetrahedronGeometry(0.14, 0), color: "#75787f", position: [0, 0.3, -0.16], rotation: [0.3, 0.7, 0.1] },
      { geometry: new THREE.CylinderGeometry(0.1, 0.08, 0.1, 8), color: "#211f1a", position: [0, 0.16, 0.04] },
      { geometry: new THREE.IcosahedronGeometry(0.09, 0), color: "#e3c93a", position: [-0.08, 0.22, 0.12], rotation: [0.2, 0.4, 0.3], scale: [1.2, 0.45, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#f2dd5a", position: [0.1, 0.22, 0.12], rotation: [0.3, 1, 0.2], scale: [1.1, 0.45, 1] },
      { geometry: new THREE.TetrahedronGeometry(0.06, 0), color: "#e3c93a", position: [0, 0.28, 0], rotation: [0.4, 0.6, 0.3] },
      { geometry: new THREE.TetrahedronGeometry(0.055, 0), color: "#f2dd5a", position: [-0.14, 0.2, 0.04], rotation: [0.2, 1.4, 0.4] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#c9ad28", position: [0.16, 0.16, 0.1], rotation: [0.2, 0.8, 0.2], scale: [1.1, 0.5, 1] },
      { geometry: new THREE.ConeGeometry(0.12, 0.26, 6), color: "#d8dadf", position: [0, 0.42, 0.04] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#d8dadf", position: [0.03, 0.58, 0.02], scale: [1, 0.8, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#c9ad28", position: [0.2, 0.04, 0.13], rotation: [0.2, 0.6, 0.2], scale: [1.1, 0.6, 1] },
      { geometry: new THREE.TetrahedronGeometry(0.06, 0), color: "#676a71", position: [-0.2, 0.04, -0.09], rotation: [0.3, 1, 0.2] },
    ],
  animations: [],
});
